import styled from "styled-components";
import theme from "./../../styles/theme"

export const BannerWrapper = styled.div`
  align-items: flex-start;
  display: flex;
  margin-top: -35px;

  @media (max-width:  ${theme.breakpoints.medium}) {
    margin-top: 0;
  }

`;

export const BannerBox = styled.div`
  width: 65%;
  margin-top: 80px;
  padding: 20px 100px;
  text-align: initial;
  position: relative;

  @media (max-width:  ${theme.breakpoints.medium}) {
    display: none;
  }
`;

export const Title = styled.h1`
  color:  ${theme.colors.landingTheme};
  font-family: ${theme.fonts.montSerrat};
  font-style: normal;
  font-weight: ${theme.fontWeights.bold};
  font-size: 34px;
  padding-top: 60px;
`;

export const Subtitle = styled.h2`
  font-family: ${theme.fonts.montSerrat};
  font-style: normal;
  font-weight: ${theme.fontWeights.bold} !important;
  font-size: 64px;
  line-height: 70px;

  span{
    color:  ${theme.colors.landingTheme};
  }
`;

export const Description = styled.p`
  font-family: ${theme.fonts.montSerrat};
  font-style: normal;
  font-weight: 500;
  font-size: ${theme.fontSizes.small};
  line-height: 22px;
  color: ${theme.colors.gray};
  padding-top: 20px;
`;

export const BannerImg = styled.div`
  margin-top: 131px;
  padding-bottom: 50px;
  width: 100%;
  h1, h2, p{
    display: none;
  }
  @media (max-width:  ${theme.breakpoints.medium}) {
    background: none;
    margin-top: 80px;
    padding: 30px 40px 50px;

    h1{
      display: flex;
      padding-top: 15px;
      font-size: 26px;
      margin-bottom: -10px;
    }
    h2{
      display: flex;
      font-size: 42px;
    }
    p{
      display: flex;
      text-align: initial;
    }
  }
`;


export const BannerMarcadagua = styled.div`
  position: absolute;
  top: 30%;
  left: 0;
`;
